import { BUSINESS_PERSONAL_TYPE } from '@ag-common-lib/public-api';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'businessPersonalTypeIcon' })
export class BusinessPersonalTypeIconPipe implements PipeTransform {
  transform(businessPersonalType: string): string {
    const cssClassName = {
      [BUSINESS_PERSONAL_TYPE.PERSONAL]: 'dx-icon-user',
      [BUSINESS_PERSONAL_TYPE.BUSINESS]: 'dx-icon-product',
    };
    return cssClassName[businessPersonalType] || 'dx-icon-more';
  }
}
